import { LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

interface EmptyStateViewProps {
  title?: string;
  description?: React.ReactNode;
  icon?: LucideIcon;
  className?: string;
  contentClassName?: string;
}

export default function EmptyStateView({
  title,
  description,
  icon: Icon,
  className = "",
  contentClassName = "",
}: EmptyStateViewProps) {
  return (
    <div
      className={cn(
        "flex flex-auto min-h-[50vh] items-start justify-center px-4 pt-12",
        className,
      )}
      data-testid="empty-state-view"
    >
      <div
        className={cn(
          "flex w-full max-w-md flex-col items-start p-6 text-left",
          contentClassName,
        )}
        data-testid="empty-state-content"
      >
        {Icon && (
          <div className="mb-6 self-center flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Icon
              className="h-8 w-8 text-primary"
              data-testid="empty-state-icon"
            />
          </div>
        )}
        <h3 className="mb-2 text-xl font-semibold text-foreground">{title}</h3>
        <div className="mb-2 w-full text-sm leading-relaxed text-muted-foreground">
          {description}
        </div>
      </div>
    </div>
  );
}
